export default function IconEye() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="18"
      viewBox="0 0 27 18"
    >
      <path
        id="eye"
        d="M13.5-14.25a5.069,5.069,0,0,1,3.727,1.523,5.041,5.041,0,0,1,1.523,3.7,5.041,5.041,0,0,1-1.523,3.7,5.041,5.041,0,0,1-3.7,1.523A5.041,5.041,0,0,1,9.82-5.32,5.014,5.014,0,0,1,8.3-9a5.615,5.615,0,0,1,.188-1.453,2.636,2.636,0,0,0,1.266.328A2.526,2.526,0,0,0,11.6-10.9a2.526,2.526,0,0,0,.773-1.852,2.636,2.636,0,0,0-.328-1.266A4.565,4.565,0,0,1,13.5-14.25ZM26.859-9.7A1.766,1.766,0,0,1,27-9a1.766,1.766,0,0,1-.141.7,15.662,15.662,0,0,1-5.531,6.023A14.261,14.261,0,0,1,13.5,0,14.261,14.261,0,0,1,5.672-2.273,15.662,15.662,0,0,1,.141-8.3,1.766,1.766,0,0,1,0-9a1.766,1.766,0,0,1,.141-.7,15.662,15.662,0,0,1,5.531-6.023A14.261,14.261,0,0,1,13.5-18a14.261,14.261,0,0,1,7.828,2.273A15.662,15.662,0,0,1,26.859-9.7ZM7.031-4.031A12.451,12.451,0,0,0,13.5-2.25a12.209,12.209,0,0,0,6.445-1.8A13.036,13.036,0,0,0,24.656-9a13.036,13.036,0,0,0-4.711-4.945,12.209,12.209,0,0,0-6.445-1.8,12.209,12.209,0,0,0-6.445,1.8A13.036,13.036,0,0,0,2.344-9,13.277,13.277,0,0,0,7.031-4.031Z"
        transform="translate(0 18)"
        fill="#707070"
      />
    </svg>
  );
}
